<template>
  <b-tooltip
    boundary="window"
    v-if="showToolTip"
    triggers="none"
    :placement="placement"
    :target="target"
    :show="showToolTip"
    :custom-class="'alert-tooltip ' + containerClass"
  >
    <div class="tooltip-container text-left">
      <div class="text-big bold mb-2" v-if="heading">{{ heading }}</div>
      <div class="text-medium mb-2">{{ message }}</div>
      <div class="text-right">
        <b-button @click="hide" class="dismiss-btn text-medium" variant="primary" pill
          >Got it
        </b-button>
      </div>
    </div>
  </b-tooltip>
</template>

<script>
import { BButton, BTooltip } from 'bootstrap-vue'

/**
 * This component can be used to show an alert tooltip beside any element. It receives a prop - target which is the id of the element where tooltip should be placed.
 */
export default {
  name: 'AlertTooltip',
  props: {
    heading: String,
    message: String,
    target: String,
    placement: {
      default: 'bottomleft',
      type: String
    },
    containerClass: {
      default: '',
      type: String
    }
  },
  components: { BButton, BTooltip },
  data() {
    return {
      showToolTip: false
    }
  },
  computed: {},
  methods: {
    hide() {
      this.showToolTip = false
      this.$emit('dismiss')
    },
    /**
     * This can be called by parent component to show the tooltip
     */
    show() {
      this.showToolTip = true
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.tooltip-container {
  padding: 16px 12px;
}

.dismiss-btn {
  padding: 4px 24px;
  margin-top: 6px;
}

.alert-tooltip /deep/ .tooltip-inner {
  border-radius: 10px;
}
</style>
